// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__7PBRV","version":"footer_version__9xWuw"};